import {useMutation, useQuery} from '@apollo/react-hooks';
import {Dialog, DialogActions, DialogContent, DialogTitle, FormControl, MenuItem, Select} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import PropTypes from 'prop-types';
import React, {useRef, useState} from 'react';
import {Query} from 'react-apollo';

import {UrlasserDialog} from '.';
import {GET_BLINKER_SPECIAL_CONTENT, GET_SIGN_IMAGE_CONTENTS, GET_SIGN_STATE, SWITCH_PROGRAMS} from './queries/dialog.queries';
import './styles/dialog.scss';

import CircularProgress from '@material-ui/core/CircularProgress';

import gql from 'graphql-tag';
import {useParams} from 'react-router-dom';
import checkAuthorization from '../Authorization/Authorization';
import DisplayContent from '../Device/components/DisplayContent';

const GET_CURRENT_USER = gql`
    query {
        currentUser {
            id
            username
            name
            accessAuthorizations {
                id
                canPerformActions
            }
        }
    }
`;

const GET_PROJECT = gql`
    query central($id: String!) {
        central(id: $id) {
            id
            project_id
        }
    }
`;

const DATA_POLL_INTERVAL = 5000;

const SwitchProgramDialog = props => {
    /////////////////////////////////////////////////////////////////////////////////////////////////////
    const {centralID} = useParams();
    const {data: currentUserData} = useQuery(GET_CURRENT_USER, {fetchPolicy: 'cache-first'});
    const {data: currentProject} = useQuery(GET_PROJECT, {variables: {id: centralID}});
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const {source, open, onClose, onVerifyClick} = props;
    const [openUrlasserDialog, setOpenUrlasserDialog] = useState(false);
    const [values, setValues] = React.useState({});
    const [switchProgram] = useMutation(SWITCH_PROGRAMS);

    const [initialValue, setInitialValue] = useState(true);

    const refValues = useRef({});

    const allSigns = [];

    if (open) {
        source.crosssections.forEach(crosssection => {
            crosssection.devices.forEach(device => {
                if (device.device_type === 'Sign') {
                    allSigns.push(device);
                }
            });
        });
    }

    const handleUrlasserDialogClose = () => {
        setOpenUrlasserDialog(false);
    };

    function handleUrlasserDialogVerifyClick(username, cause, initiator) {
        let programs = [];
        for (let [sign_id, value] of Object.entries(values)) {
            if (value) {
                programs.push({device_id: sign_id, program: value === 'auto' ? null : value});
            }
        }

        try {
            switchProgram({variables: {programs: programs, cause: cause, initiator: initiator}});
        } catch (err) {
            console.log(err);
        }

        setOpenUrlasserDialog(false);
        onVerifyClick();
    }

    const handleVerifyClicked = () => {
        // setOpenUrlasserDialog(true);
        checkAuthorization(currentUserData, currentProject, document.getElementById('authentication_problem'), () => {
            setOpenUrlasserDialog(true);
        });
    };

    const handleChange = name => event => {
        setInitialValue(false);
        refValues.current = {...refValues.current, [name]: event.target.value};
        // setValues({ ...values, [name]: event.target.value });
        setValues({...refValues.current, [name]: event.target.value});
    };

    const handleClose = () => {
        setValues({});
        onClose();
    };

    return (
        <React.Fragment>
            <UrlasserDialog
                onVerifyClick={handleUrlasserDialogVerifyClick}
                onClose={handleUrlasserDialogClose}
                open={openUrlasserDialog}
            />
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Einstellung Programm</DialogTitle>

                <DialogContent>
                    <Table size="medium">
                        <TableHead>
                            <TableRow>
                                <TableCell>Name</TableCell>
                                <TableCell>aktuell</TableCell>
                                <TableCell>Befehl</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {allSigns.map(sign => (
                                <Query key={sign.name} query={GET_SIGN_STATE} variables={{id: sign.id}} fetchPolicy="no-cache">
                                    {({data, error, loading}) => {
                                        if (loading) {
                                            // return <Spinner />;
                                            return (
                                                <React.Fragment>
                                                    <TableRow key={sign.name}>
                                                        <TableCell component="th" scope="row">
                                                            <span className="nameField">{sign.name}</span>
                                                        </TableCell>
                                                        <TableCell component="th" scope="row">
                                                            <CircularProgress className="loading" />
                                                        </TableCell>
                                                        <TableCell component="th" scope="row">
                                                            <CircularProgress className="loading" />
                                                        </TableCell>
                                                    </TableRow>
                                                    {sign.blinking_lights !== null ? (
                                                        <TableRow key={sign.name + ' Blinker'}>
                                                            <TableCell component="th" scope="row">
                                                                <span className="nameField">{sign.name + ' Blinker'}</span>
                                                            </TableCell>
                                                            <TableCell>
                                                                <CircularProgress className="loading" />
                                                            </TableCell>
                                                            <TableCell>
                                                                <CircularProgress className="loading" />
                                                            </TableCell>
                                                        </TableRow>
                                                    ) : (
                                                        <React.Fragment></React.Fragment>
                                                    )}
                                                </React.Fragment>
                                            );
                                        }
                                        let sign_state = {};
                                        // let sign_command = {};
                                        let blinking_lights_state = {};
                                        // let blinking_lights_command = {};

                                        if (data !== undefined && data.device !== undefined) {
                                            if (data.device.sign_state) {
                                                sign_state = data.device.sign_state;
                                            }
                                            // if (data.device.sign_command) {
                                            //   sign_command = data.device.sign_command;
                                            // }

                                            if (!values[sign.id]) {
                                                refValues.current = {...refValues.current, [sign.id]: data.device.sp_image_content};
                                            }
                                        }

                                        // if(!values[sign.id]) {
                                        // if(sign_command.program_state === 2) {
                                        //   // setValues({ ...values, [sign.id]: sign_command.program });
                                        //   refValues.current = { ...refValues.current, [sign.id]: sign_command.program }
                                        // } else {
                                        //   // setValues({ ...values, [sign.id]: "auto" });
                                        //   refValues.current = { ...refValues.current, [sign.id]: "auto" }
                                        // }
                                        // }

                                        if (data !== undefined) {
                                            if (sign.blinking_lights !== null) {
                                                blinking_lights_state = data.device.blinking_lights.blinking_lights_state;
                                                // if(data.device.blinking_lights.blinking_lights_command) {
                                                //   blinking_lights_command = data.device.blinking_lights.blinking_lights_command;
                                                // }
                                                if (!values[sign.blinking_lights.id]) {
                                                    // if(blinking_lights_command.program_state === 2) {
                                                    // // setValues({ ...values, [sign.blinking_lights.id]: blinking_lights_command.program });
                                                    // refValues.current = { ...refValues.current, [sign.blinking_lights.id]: blinking_lights_command.program }
                                                    refValues.current = {
                                                        ...refValues.current,
                                                        [sign.blinking_lights.id]: data.device.blinking_lights.sp_image_content,
                                                    };
                                                    // } else {
                                                    // // setValues({ ...values, [sign.blinking_lights.id]: "auto" });
                                                    // refValues.current = { ...refValues.current, [sign.blinking_lights.id]: "auto" }
                                                    // }
                                                }
                                            }
                                        }

                                        return (
                                            <React.Fragment>
                                                <TableRow key={sign.name}>
                                                    <TableCell component="th" scope="row">
                                                        <span className="nameField">{sign.name}</span>
                                                    </TableCell>
                                                    <TableCell>
                                                        <span className="actualProgramField">
                                                            {sign_state.program &&
                                                                (sign_state.program === 'N/A' ? (
                                                                    <span>N/A</span>
                                                                ) : (
                                                                    // <SignImageContent imageID={sign_state.program}/>}
                                                                    <DisplayContent
                                                                        signType={sign.sign_type}
                                                                        ID={sign.id}
                                                                        contentID={sign_state.program}
                                                                    />
                                                                ))}
                                                        </span>
                                                    </TableCell>
                                                    {/* <ProgramSelect signType={sign.sign_type} signId={sign.id} value={values[sign.id]} onChange={handleChange(sign.id)} initValue={initialValue} /> */}
                                                    <ProgramSelect
                                                        signType={sign.sign_type}
                                                        signId={sign.id}
                                                        value={refValues.current[sign.id]}
                                                        onChange={handleChange(sign.id)}
                                                        initValue={initialValue}
                                                    />
                                                </TableRow>
                                                {sign.blinking_lights !== null ? (
                                                    <TableRow key={sign.name + ' Blinker'}>
                                                        <TableCell component="th" scope="row">
                                                            <span className="nameField">{sign.name + ' Blinker'}</span>
                                                        </TableCell>
                                                        <TableCell>
                                                            <span className="actualProgramField">
                                                                {sign_state.program &&
                                                                    (sign_state.program === 'N/A' ? (
                                                                        <span>N/A</span>
                                                                    ) : blinking_lights_state.program === 'Dunkel' ? (
                                                                        'Aus'
                                                                    ) : (
                                                                        'An'
                                                                    ))}
                                                            </span>
                                                        </TableCell>
                                                        {/* <BlinkingLightsSelect value={values[sign.blinking_lights.id]} blinkerId={sign.blinking_lights.id} initValue={initialValue} onChange={handleChange(sign.blinking_lights.id)} /> */}
                                                        <BlinkingLightsSelect
                                                            value={refValues.current[sign.blinking_lights.id]}
                                                            blinkerId={sign.blinking_lights.id}
                                                            initValue={initialValue}
                                                            onChange={handleChange(sign.blinking_lights.id)}
                                                        />
                                                    </TableRow>
                                                ) : (
                                                    <React.Fragment></React.Fragment>
                                                )}
                                            </React.Fragment>
                                        );
                                    }}
                                </Query>
                            ))}
                        </TableBody>
                    </Table>
                </DialogContent>

                <DialogActions>
                    <p id="authentication_problem" style={{color: 'red'}}></p>
                    <Button color="primary" onClick={handleClose}>
                        Abbrechen
                    </Button>
                    <Button color="primary" variant="contained" onClick={handleVerifyClicked}>
                        Übernehmen
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
};

const ProgramSelect = props => {
    const {signType, signId, value, onChange, initValue} = props;
    const {data} = useQuery(GET_SIGN_IMAGE_CONTENTS, {variables: {id: signId}, pollInterval: {DATA_POLL_INTERVAL}});
    if (data) {
        if (value === undefined) {
            return null;
        }
        return (
            <FormControl>
                <Select className="programSelect" value={initValue ? data.device.sp_image_content : value} onChange={onChange}>
                    <MenuItem key={0} value={'auto'}>
                        <span>Automatik</span>
                    </MenuItem>
                    {data.device.image_contents &&
                        data.device.image_contents.map(item => (
                            <MenuItem key={item} value={item}>
                                {/* <SignImageContent imageID={item}/> */}
                                <DisplayContent contentID={item} ID={signId} signType={signType} />
                            </MenuItem>
                        ))}
                </Select>
            </FormControl>
        );
    } else {
        return null;
    }
};

const BlinkingLightsSelect = props => {
    const {value, blinkerId, initValue, onChange} = props;
    const {data} = useQuery(GET_BLINKER_SPECIAL_CONTENT, {variables: {id: blinkerId}, pollInterval: {DATA_POLL_INTERVAL}});
    if (data) {
        if (value === undefined) {
            return null;
        }
        return (
            <FormControl>
                <Select className="programSelect" value={initValue ? data.device.sp_image_content : value} onChange={onChange}>
                    <MenuItem key={0} value={'auto'}>
                        <span>Automatik</span>
                    </MenuItem>
                    <MenuItem key={1} value={'Dunkel'}>
                        <span>Aus</span>
                    </MenuItem>
                    <MenuItem key={2} value={'TLS.GelbesBlinklicht'}>
                        <span>An</span>
                    </MenuItem>
                </Select>
            </FormControl>
        );
    } else {
        return null;
    }
};

SwitchProgramDialog.propTypes = {
    source: PropTypes.object.isRequired,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onVerifyClick: PropTypes.func.isRequired,
};

export default SwitchProgramDialog;
